/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
import * as _ from 'lodash'

// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import { UpdatePopupWrap } from './index.style'
import StorageUtils from '@utils/storage-utils'

const UpdatePopup: React.FC = () => {
  const { globalStore, componentStore } = useRootStore()
  const { visibleForefrontPopup } = globalStore
  const { forefrontPopups, removeForefrontPoupById, setNoticeDetail } = componentStore
  const [ forefrontPopup, setForefrontPopup ] = useState(null)

  const onCloseModal = () => {
    const { id, displayStartAt } = forefrontPopup
    updatePopupListByRead(id, displayStartAt) // 전면팝업을 읽지 않고 닫을때도 localStorage.foreFrontPopupShowList 에 추가
    removeForefrontPoupById(id)
  }

  const onClickBanner = () => {
    const { notice } = forefrontPopup
    setNoticeDetail(notice)
    globalStore.setVisibleNoticeDetail(true)
    notice.isVisibleMatchup = false
    componentStore.updateMatchupNotice(notice)
    onCloseModal()
  }

  const updatePopupListByRead = (id, displayStartAt) => {
    const storageItem = StorageUtils.getForeFrontPopupList()

    if (!_.isEmpty(storageItem)) {
      _.remove(storageItem, item => item.id === id)
    }

    storageItem.push({
      id,
      displayStartAt,
    })
    StorageUtils.saveForeFrontPopupShowList(storageItem)
  }

  useEffect(() => {
    if (_.size(forefrontPopups) > 0) {
      setForefrontPopup(_.head(forefrontPopups))
    } else {
      globalStore.setVisibleForefrontPopup(false)
    }
  }, [forefrontPopups])

  return (
    <Modal
      transparent
      visible={visibleForefrontPopup}
      maskClosable={false}
      onClose={onCloseModal}
      className="event"
      wrapClassName="guide-notice-popup first-guide-popup"
    >
      <UpdatePopupWrap>
        <Button onClick={onCloseModal} className={isMobile? 'close-btn update-cls-btn': 'close-btn update-cls-btn pc'} css={CloseBtn}>
          <span className="close-txt">닫기</span>
        </Button>
        <Button TP onClick={onClickBanner} className="update-banner-btn">
          {forefrontPopup && <img src={forefrontPopup.imageUrl || ''} alt="업데이트 내용"/>}
        </Button>
      </UpdatePopupWrap>
      <ModalBg className="modal-bg"/>
    </Modal>
  )
}

export default observer(UpdatePopup)
